import React from 'react';

const NotFoundPage: React.FC = () => {

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        fontSize: '6rem',
        fontWeight: 'bold',
        color: '#000000',
        marginBottom: '1rem'
      }}>
        404
      </div>
      
      <h1 style={{
        fontSize: '2rem',
        fontWeight: '600',
        color: '#374151',
        marginBottom: '1rem'
      }}>
        Invalid URL
      </h1>
      
      <p style={{
        fontSize: '1.1rem',
        color: '#6b7280',
        marginBottom: '2rem',
        maxWidth: '500px'
      }}>
        Sorry, the page you are looking for doesn't exist or the URL is invalid. 
        Please check the URL and try again.
      </p>
    </div>
  );
};

export default NotFoundPage;